module.exports = __webpack_public_path__ + "img/preSale.f9c04d05.png";